import { changeLoaderState } from "../reducers/agentReducer";


export const changeLoaderStatus = async(dispatch, user) => {
    dispatch(changeLoaderState(user));
}